import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonSegmentsRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/segments/others` — the address the embedded app's Segments views link
 * to. It forwards to the tab's own URL once the rollout flag is on, and renders the embedded app in
 * place while it is off.
 */
function JourneysPersonSegmentsOthersRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonSegmentsRoute personId={personId} view="others" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/segments/others',
)({
  component: JourneysPersonSegmentsOthersRoute,
});
